import ProjectsList from '../projects/ProjectsList';
const AccountantProjectsList = () => <ProjectsList />;
export default AccountantProjectsList; 